import React, { Suspense } from 'react';
import { Badge, BadgeProps, styled } from '@mui/material';
import { IoMdNotificationsOutline } from 'react-icons/io';
import { Button } from '../Button';

interface NotificationIconProps {
	count: number;
}

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
	'& .MuiBadge-badge': {
		right: -3,
		top: 13,
		border: `2px solid ${theme.palette.background.paper}`,
		padding: '0 4px',
	},
}));

export const NotificationIcon: React.FC<NotificationIconProps> = ({ count }) => {
	return (
		<Suspense fallback={null}>
			<Button variant="icon" size="icon" rounded={'full'}>
				<StyledBadge badgeContent={count} color="secondary">
					<IoMdNotificationsOutline size={25} />
				</StyledBadge>
			</Button>
		</Suspense>
	);
};
